import { render, staticRenderFns } from "./distribute-list.vue?vue&type=template&id=24d850fa&scoped=true"
import script from "./distribute-list.vue?vue&type=script&lang=js"
export * from "./distribute-list.vue?vue&type=script&lang=js"
import style0 from "./distribute-list.vue?vue&type=style&index=0&id=24d850fa&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d850fa",
  null
  
)

export default component.exports